module.exports = __webpack_public_path__ + "asset/img/bei.f4c933f4.png";